import axios from 'axios';
import { Rank } from '../interface';

export async function getRanks(): Promise<Array<Rank>> {
  const { data } = await axios.get<{ ranks: Array<Rank> }>('https://ninimo.thepinkfong.com/api/ranks');
  return data.ranks || [];
}
export async function applyRanks(value: string): Promise<number> {
  const { data } = await axios.post<{ rank: number }>('https://ninimo.thepinkfong.com/api/ranks', {
    data: value,
  });

  return data.rank || -1;
}
